export default __webpack_public_path__ + "static/media/dashboard.b86ce3bd.svg";